import React from "react";
import { SortState } from "@/hooks/useTableState";

/**
 * A sortable column header. The <th> carries aria-sort (what screen readers announce); the
 * clickable target is a real <button> so it is keyboard-operable.
 */
interface Props {
  label: string;
  sortKey: string;
  sort: SortState;
  onSort: (key: string) => void;
  align?: "left" | "right";
  className?: string;
}

const SortableHeader: React.FC<Props> = ({
  label,
  sortKey,
  sort,
  onSort,
  align = "left",
  className = "",
}) => {
  const active = sort.key === sortKey;
  const ariaSort = active ? (sort.dir === "asc" ? "ascending" : "descending") : "none";
  return (
    <th
      scope="col"
      aria-sort={ariaSort}
      className={`px-3 py-2.5 text-xs font-semibold uppercase tracking-wide ${
        align === "right" ? "text-right" : "text-left"
      } ${active ? "text-cyan-300" : "text-gray-300"} ${className}`}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={`inline-flex items-center gap-1 rounded hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500 ${
          align === "right" ? "flex-row-reverse" : ""
        }`}
      >
        {label}
        <span aria-hidden="true" className={active ? "" : "text-gray-600"}>
          {active ? (sort.dir === "asc" ? "▲" : "▼") : "↕"}
        </span>
      </button>
    </th>
  );
};

export default SortableHeader;
